import { useMutation, useQueryClient } from "@tanstack/react-query";
import { prototypeApi } from "../service/prototype-service";
import { PROTOTYPES_QUERY_KEY } from "../queries/prototypes";

export function useAdminLoginMutation() {
    return useMutation({
        mutationFn: (password: string) => prototypeApi.adminLogin(password),
    });
}

export function useCreatePrototypeMutation() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (data: { adminPassword: string; name: string; password: string; htmlFile: File }) =>
            prototypeApi.create(data.adminPassword, {
                name: data.name,
                password: data.password,
                htmlFile: data.htmlFile,
            }),
        onSuccess: () => qc.invalidateQueries({ queryKey: [PROTOTYPES_QUERY_KEY] }),
    });
}

export function useDeletePrototypeMutation() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (data: { adminPassword: string; slug: string }) =>
            prototypeApi.delete(data.adminPassword, data.slug),
        onSuccess: () => qc.invalidateQueries({ queryKey: [PROTOTYPES_QUERY_KEY] }),
    });
}

export function useVerifyPrototypeMutation() {
    return useMutation({
        mutationFn: ({ slug, password }: { slug: string; password: string }) =>
            prototypeApi.verifyAndGetHtml(slug, password),
    });
}
